<template>
    <div class="flex-level">
        <div class="ellipsis search-result-item gray-100">
            <span>{{ data.name }}</span>
        </div>
        <div class="ellipsis search-result-item ml-2 gray-60">
            <span>{{ data.ident }}</span>
        </div>
        <div class="ellipsis search-result-item ml-2 gray-60">
            <chip-label :color="data.status.color" :label="data.status.label" />
        </div>
        <div class="ellipsis search-result-item ml-2 gray-60">{{ getName() }}</div>
        <div class="ellipsis search-result-item ml-2 gray-60">
            <span>{{ data.amount }}</span>
        </div>
        <div v-if="data.link" class="flex-right"><i class="icon-chevron-right gray-60"></i></div>
    </div>
</template>

<script>
import ChipLabel from 'vcomponents/utilities/ChipLabel.vue';
export default {
    components: {
        ChipLabel,
    },
    props: {
        data: {
            type: Object,
            required: true,
        },
    },
    methods: {
        getName() {
            return this.data.related.type === 'individual'
                ? this.data.related.last_name
                : this.data.related.name;
        },
    },
};
</script>
